import { authorsfetchCard, authorsGetCard } from "./authors.js";
import CONFIG from "./../config.json";
import { cacheGetCacheTime } from "./cache.js";
import {browserImageIsReady,
        browserCanShare,
        browserShare} from "./browser.js";
import {postersSetPosterResposiveWidth,
        getPostersMaximumImageWidth,
        postersEscapeSpacesAndApostrophes,
        postersReplaceApostrophesInText,
        postersGetYear,
        postersGetDateString,
        postersGetEndDateOrTime} from "./posters.js";
import {mapsRegion,
        mapsTown,
        mapsLabel} from "./maps.js";

import {validateAndReturnComments,
        validateAndReturnDescription }from "./validate.js";


const POSTER_MINIMUM_WIDTH = 290;

function posterFetchPosterId(parent, id, wrapper) {
    return new Promise(function (resolve, reject) {
        let resource =
                `${CONFIG.posters_api_url}/resource/poster/public/${parent}/${id}`;

        const cacheTime = cacheGetCacheTime();
        if (cacheTime !== null && cacheTime !== "") {
            resource += "?cacheTime=" + cacheTime;
        }

        fetch(resource)
                .then((response) => response.json())
                .then((aux) => {
                    posterCreateAndAppend(aux, wrapper);
                    resolve(true);
                })
                .catch((err) => {
                    reject(err);
                });
    });
}

function posterStartUp() {
    const params = new URL(document.location).searchParams;
    const posterId = params.get("id");
    const posterParent = params.get("parent");

    posterFetchPosterId(
            posterParent,
            posterId,
            document.getElementById("mainPostersWrapper")
            )
            .then(() => {
            })
            .catch((err) => {
                window.alert("Alguna cosa ha anat malament: " + err);
            })
            .finally(() => {
                document.getElementById("mainLoader").style = "display: none;";
            });
}

function posterRender(parent = document) {
    const wrappers = parent.getElementsByClassName("posterWrapper");

    if (wrappers.length > 0) {
        [].forEach.call(wrappers, (poster) => {
            const posterImages = poster.getElementsByClassName("posterImage");

            if (posterImages.length > 0) {
                browserImageIsReady(posterImages[0]).then(() => {
                    const maximumImageWidth = getPostersMaximumImageWidth(
                            posterImages[0].naturalWidth,
                            posterImages[0].naturalHeight
                            );
                    postersSetPosterResposiveWidth(poster, maximumImageWidth);
                });
            }
        });
}
}

function posterCreatePosterElement(poster) {
    // Create poster element ---------------------------------------------------
    const wrapper = document.createElement("article");
    wrapper.setAttribute("class", "posterWrapper mainItem");
    wrapper.setAttribute("data-author-id", poster.publisherId);
    wrapper.setAttribute("data-post-id", poster.id);
    wrapper.setAttribute("data-post-lng", poster.geoPt.longitude);
    wrapper.setAttribute("data-post-lat", poster.geoPt.latitude);
    //
    const relativeLink =
            "/" +
            encodeURIComponent(postersEscapeSpacesAndApostrophes(poster.id)) +
            ".html?id=" +
            poster.publisherId;
    let posterTemplate =
            "<h3><a class='posterTitle' href='" +
            relativeLink +
            "'>" +
            poster.title +
            "</a></h3>" +
            "<h4>" +
            poster.subtitle +
            "</h4>";
    posterTemplate += "<div><a href='" + poster.pictureUrl;
    posterTemplate +=
            "'><div class='posterImageWrapper'><img class='posterImage' src='" +
            poster.pictureUrl +
            "' alt='" +
            postersReplaceApostrophesInText(
                    "Cartell de '" +
                    poster.title +
                    "' de " +
                    poster.town +
                    " del " +
                    postersGetYear(poster.dateBegin)
                    ) +
            "'></div></a></div>";
    posterTemplate += "<div class='posterDateTimeWrapper'><div>";
    posterTemplate += postersGetDateString(poster.dateBegin);
    posterTemplate += "</div><div>";
    posterTemplate += postersGetEndDateOrTime(
            poster.dateBegin,
            poster.dateEnd,
            poster.timeBegin
            );
    posterTemplate += "</div></div>";
    posterTemplate +=
            "<div class='posterMoreInfo'><div class='posterWebLinkWrapper'>";
    posterTemplate +=
            "<a class='posterWebLink' href='http://" +
            poster.webLink +
            "'>" +
            poster.webLink +
            "</a>";
    posterTemplate += "</div>";
    posterTemplate +=
            "<div class='posterTooltip' onmouseover='onBrowserTooltip(event);'>?<span class='posterTooltiptext'>";
    posterTemplate += validateAndReturnDescription(poster.description);
    posterTemplate += "</span></div></div>";
    posterTemplate += "<div class='posterCommentsWrapper'>";
    posterTemplate += validateAndReturnComments(poster.comments);
    posterTemplate += "</div>";
    posterTemplate += "<div class='posterTags'>";
    posterTemplate += "<div class='posterRegionWrapper'>";
    posterTemplate +=
            "<a class='posterLocation' href='map.html?lat=" +
            poster.geoPt.latitude +
            "&lng=" +
            poster.geoPt.longitude +
            "&zoom=15'><img src='/images/map_ccc.png' class='posterLocationImage'></a>";
    posterTemplate +=
            "<a class='posterLabel' href='" +
            mapsTown(poster.region, poster.town) +
            "'>" +
            poster.town +
            "</a>";
    posterTemplate +=
            "<a class='posterLabel' href='" +
            mapsRegion(poster.region) +
            "'>" +
            poster.region +
            "</a>";
    posterTemplate += "</div>";
    posterTemplate += "<div class='posterLabelWrapper'>";
    poster.labelsList.forEach((value) => {
        posterTemplate +=
                "<a class='posterLabel' href='" +
                mapsLabel(poster.region, value) +
                "'>" +
                value +
                "</a>";
    });
    posterTemplate += "</div>";
    posterTemplate += "</div>";
    posterTemplate += "<div class='posterAuthor' style='clear:both;'><div class='poster-pre'>";
    posterTemplate += "Publicat per:</div>";
    posterTemplate +=
            "<div class='posterAuthorWrapper' data-author-attached=false data-author-id='";
    posterTemplate += poster.publisherId;
    posterTemplate += "'></div></div>";

    posterTemplate +=
            "<div class='posterSocial' style='clear:both; padding-top: 1em;'><div class='poster-pre'>" +
            "Gràcies per compartir-ho" +
            "</div>" +
            "<div class='posterShare' data-href='https://cartells.elmolideponent.com/" +
            relativeLink +
            "'></div>" +
            // + "<div style='margin-top: 1em;'><div class='fb-like' data-width='' data-layout='button_count' data-action='like' data-size='large' data-share='true' data-href='https://cartells.elmolideponent.com/"
            // + relativeLink
            // + "'></div></div>"
            "</div>";

    //
    wrapper.innerHTML = posterTemplate;

    return wrapper;
}

function posterParseDocument() {
    const posterSocial = document.getElementById("posterSocial");
    posterParse(posterSocial);
}

function posterParse(element) {
    if (browserCanShare() === true) {
        const share = element.getElementsByClassName("posterShare");

        const anchor = document.createElement("a");
        anchor.setAttribute("class", "anchorShare");
        anchor.href = "javascript:void(0)";
        anchor.innerText = "Compartir";
        share[0].appendChild(anchor);

        anchor.addEventListener("click", (event) => {
            browserShare(share[0].dataset.href);
        });
    }
}

function posterCreateAndAppend(poster, parent) {
    // appending the poster --------------------------------------------
    const posterElement = posterCreatePosterElement(poster);
    parent.appendChild(posterElement);

    // appending author card -------------------------------------------
    posterAppendAuthor(posterElement);

    // facebook share button ----------------------------------------------
    // fbParse(posterElement);

    // poster share button
    posterParse(posterElement);

    return posterElement;
}

function posterAppendAuthor(posterElement) {
    const authorWrappers = posterElement.getElementsByClassName(
            "posterAuthorWrapper"
            );
    (function () {
        const auxElement = authorWrappers[0];
        authorsfetchCard(auxElement.getAttribute("data-author-id")).then(
                (author) => {
            auxElement.innerHTML = authorsGetCard(author);
            auxElement.setAttribute("data-author-attached", true);
        }
        );
    })();
}

export {
posterAppendAuthor,
        posterCreateAndAppend,
        posterRender,
        posterStartUp,
        posterParse,
        posterParseDocument,
        posterFetchPosterId,
        POSTER_MINIMUM_WIDTH
};
